import connect from './connect';
import PasswordSettings from './PasswordSettings';

export default connect(PasswordSettings);
